import classnames from "classnames";

import logo from "@/assets/images/uptime-desktop-logo.svg";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {PropsWithClassName} from "@/lib/types/props.ts";

import style from "./NavBar.module.scss";

export const NavBar = ({className}: PropsWithClassName) => (
  <nav className={classnames("navbar", style.navBar, className)}>
    <div className={classnames("container-fluid", style.container)}>
      <a className="navbar-brand" href={URL_ORIGINAL_WEBSITE}>
        <img src={logo} alt="Uptime.com Logo" className={style.image} />
      </a>
    </div>
  </nav>
);
